/* 7 O'CLOCK – Brooklyn Mix & Match (sections/7oc-becher-set.liquid), 06.10.2026
   Becher 2er Set (fest) + Deckelfarben mit Menge, Staffelrabatt auf alle Deckel-Sets ab Stufe 1,
   Setpreis/Ersparnis live, alles gemeinsam per Cart-API in den Warenkorb. Vanilla JS.
   Rechenweg wie Shopify: Rabatt je Stück auf volle Cent abgerundet (im Warenkorb mit 1–6 Sets geprüft, 07.10.2026). */
(function () {
  'use strict';

  var root = document.querySelector('[data-oc-bs]');
  if (!root) return;

  var SET_NAME = root.getAttribute('data-set-name') || 'Brooklyn Mix & Match';
  var FREE_SHIP = 6900;
  function parse(sel, fallback) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return fallback; } }
  var TIERS = (parse('[data-oc-bs-tiers]', []) || []).filter(function (t) { return t && t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
  var CUP = parse('[data-oc-bs-becher]', null);
  var LIDS = parse('[data-oc-bs-lids]', []) || [];
  function geoCountry() {
    try { if (window.ocPromo && window.ocPromo.geoCountry) return window.ocPromo.geoCountry(); } catch (e) {}
    try { return sessionStorage.getItem('oc-geo-country') || 'DE'; } catch (e) { return 'DE'; }
  }

  var state = { qty: {}, busy: false };
  /* Farbpunkt: Hex aus dem Farb-Metaobjekt (custom.color_new), sonst nach Farbname */
  var HEX_BY_NAME = { 'schwarz': '#2d2d2d', 'weiß': '#f3f1ec', 'weiss': '#f3f1ec', 'off-white': '#ebe6da', 'taupe': '#a89b8b', 'braun': '#5a3a2a', 'butter lemon': '#e9e28c', 'greige': '#c8c3b8', 'pink': '#ff8fc3' };
  function hexOf(l) { return l.hex || HEX_BY_NAME[(l.color || '').toLowerCase()] || '#d9c7ae'; }

  function qs(s, el) { return (el || root).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function money(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function totalLids() { return Object.keys(state.qty).reduce(function (n, k) { return n + state.qty[k]; }, 0); }
  function pctFor(n) { var p = 0; TIERS.forEach(function (t) { if (n >= t.min) p = t.pct; }); return p; }
  function nextTier(n) { for (var i = 0; i < TIERS.length; i++) if (TIERS[i].min > n) return TIERS[i]; return null; }
  function lidById(id) { for (var i = 0; i < LIDS.length; i++) if (LIDS[i].id === id) return LIDS[i]; return null; }
  function minLidPrice() { var m = 0; LIDS.forEach(function (l) { if (l.available && (!m || l.price < m)) m = l.price; }); return m || (LIDS[0] ? LIDS[0].price : 0); }

  /* ---------- Becher-Karte ---------- */
  if (CUP) {
    var img = qs('[data-oc-bs-becher-img]');
    img.src = CUP.image; img.srcset = CUP.image + ' 1x, ' + CUP.image2x + ' 2x'; img.alt = CUP.imageAlt;
    qs('[data-oc-bs-becher-name]').textContent = CUP.title;
    qs('[data-oc-bs-becher-sub]').textContent = CUP.subline || '';
    qs('[data-oc-bs-becher-price]').textContent = money(CUP.price);
    qs('[data-oc-bs-base-price]').textContent = money(CUP.price + minLidPrice());
  }

  /* ---------- Deckel-Karten ---------- */
  var tpl = qs('[data-oc-bs-card]');
  var grid = qs('[data-oc-bs-grid]');
  LIDS.forEach(function (l) {
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-id', l.id);
    buildGallery(node, l, LIDS.indexOf(l) < 4);
    qs('[data-oc-bs-name]', node).textContent = l.color;
    qs('[data-oc-bs-price]', node).textContent = money(l.price);
    if (!l.available) {
      node.classList.add('is-soldout');
      qs('.oc-mm_card-soldout', node).hidden = false;
      qs('[data-oc-bs-stepper]', node).hidden = true;
      qs('[data-oc-bs-add-one]', node).hidden = true;
    } else {
      qs('[data-oc-bs-add-one]', node).addEventListener('click', function () { setQty(l.id, 1); });
      qs('[data-oc-bs-plus]', node).addEventListener('click', function () { setQty(l.id, (state.qty[l.id] || 0) + 1); });
      qs('[data-oc-bs-minus]', node).addEventListener('click', function () { setQty(l.id, (state.qty[l.id] || 0) - 1); });
      /* Klick auf das Bild = erste Farbe wählen / eine mehr */
      qs('.oc-bs_card-img', node).addEventListener('click', function () { setQty(l.id, (state.qty[l.id] || 0) + 1); });
    }
    grid.appendChild(node);
  });

  /* Bildgalerie in der Karte wie bei Bloom: alle Produktbilder, seitlich wischbar, Punkte unten (07.10.2026) */
  function buildGallery(node, p, eager) {
    var track = qs('[data-oc-bs-track]', node), dots = qs('[data-oc-bs-dots]', node);
    if (!track || !dots) return;
    var list = (p.images || []).slice();
    if (!list.length || list[0].s !== p.image) list.unshift({ s: p.image, l: p.image2x, alt: p.imageAlt });
    list.forEach(function (im, i) {
      var img = document.createElement('img');
      img.src = im.s; img.srcset = im.s + ' 1x, ' + im.l + ' 2x'; img.alt = im.alt || p.imageAlt;
      img.loading = (eager && i === 0) ? 'eager' : 'lazy';
      img.draggable = false;
      track.appendChild(img);
      if (list.length > 1) {
        var d = document.createElement('span');
        d.className = 'oc-mm_card-dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(d);
      }
    });
    if (list.length < 2) { dots.hidden = true; return; }
    var t = false;
    track.addEventListener('scroll', function () {
      if (t) return; t = true;
      setTimeout(function () {
        t = false;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        qsa('.oc-mm_card-dot', dots).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, 50);
    }, { passive: true });
  }

  /* Wisch-Hinweis wie bei Bloom: rechte Karte der ersten Reihe schiebt das Bild einmal halb zur Seite und zurück */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var cards = qsa('[data-oc-bs-card-el]', grid);
    if (!cards.length) return;
    var cols = (getComputedStyle(grid).gridTemplateColumns || '').split(' ').filter(Boolean).length || 2;
    var card = cards[Math.min(cols, cards.length) - 1];
    var track = qs('[data-oc-bs-track]', card);
    function peek() {
      if (!track || track.scrollWidth <= track.clientWidth + 2) return;
      var dist = track.clientWidth * 0.5, out = 480, hold = 220, back = 480, start = null;
      var ease = function (x) { return x < 0.5 ? 2 * x * x : -1 + (4 - 2 * x) * x; };
      track.style.scrollSnapType = 'none';
      function frame(ts) {
        if (start === null) start = ts;
        var e = ts - start, x;
        if (e < out) x = dist * ease(e / out);
        else if (e < out + hold) x = dist;
        else if (e < out + hold + back) x = dist * (1 - ease((e - out - hold) / back));
        else { track.scrollLeft = 0; track.style.scrollSnapType = ''; return; }
        track.scrollLeft = x;
        requestAnimationFrame(frame);
      }
      setTimeout(function () { requestAnimationFrame(frame); }, 500);
    }
    if (!('IntersectionObserver' in window)) { peek(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { io.disconnect(); peek(); } });
    }, { threshold: 0.6 });
    io.observe(card);
  })();

  function setQty(id, n) {
    n = Math.max(0, Math.min(10, n));
    if (n === 0) delete state.qty[id]; else state.qty[id] = n;
    update();
  }

  /* ---------- Anzeige ---------- */
  function update() {
    var n = totalLids();
    var pct = pctFor(n);
    var lidsSum = 0, discount = 0;
    var chosen = [];
    Object.keys(state.qty).forEach(function (k) {
      var l = lidById(parseInt(k, 10)); if (!l) return;
      var q = state.qty[k];
      var line = q * l.price;
      lidsSum += line;
      discount += Math.floor(l.price * pct / 100) * q; /* wie Shopify: Rabatt je Stück auf volle Cent abgerundet (07.10.2026) */
      chosen.push({ lid: l, qty: q });
    });
    var cupPrice = CUP ? CUP.price : 0;
    var was = cupPrice + lidsSum;
    var set = was - discount;

    /* Karten */
    qsa('[data-oc-bs-card-el]').forEach(function (c) {
      var id = parseInt(c.getAttribute('data-id'), 10);
      var q = state.qty[id] || 0;
      var l = lidById(id);
      c.classList.toggle('is-selected', q > 0);
      qs('[data-oc-bs-qty]', c).textContent = q;
      var cnt = qs('[data-oc-bs-count]', c);
      cnt.hidden = q === 0; cnt.textContent = q > 1 ? q + '×' : ''; cnt.classList.toggle('is-check', q === 1); /* 1× = Haken wie beim Becher */
      if (l && l.available) {
        qs('[data-oc-bs-stepper]', c).hidden = q === 0;
        qs('[data-oc-bs-add-one]', c).hidden = q > 0;
        var tierEl = qs('[data-oc-bs-tier-lbl]', c);
        if (pct > 0) { tierEl.textContent = '-' + pct + ' % Staffelrabatt'; tierEl.classList.remove('is-muted'); }
        else if (TIERS[0]) { tierEl.textContent = 'Ab ' + TIERS[0].min + ' Farben -' + TIERS[0].pct + ' %'; tierEl.classList.add('is-muted'); }
        var priceEl = qs('[data-oc-bs-price]', c), wasEl = qs('[data-oc-bs-was]', c);
        if (pct > 0 && n > 0) {
          priceEl.textContent = money(l.price - Math.floor(l.price * pct / 100)); priceEl.classList.remove('is-regular');
          wasEl.textContent = money(l.price); wasEl.hidden = false;
        } else {
          priceEl.textContent = money(l.price); priceEl.classList.add('is-regular'); wasEl.hidden = true;
        }
      }
    });

    /* Staffel-Leiter */
    var curMin = 0;
    qsa('[data-oc-bs-tier]').forEach(function (t) { var m = parseInt(t.getAttribute('data-oc-bs-tier'), 10); if (n >= m && m > curMin) curMin = m; });
    qsa('[data-oc-bs-tier]').forEach(function (t) {
      var min = parseInt(t.getAttribute('data-oc-bs-tier'), 10);
      t.classList.toggle('is-done', n >= min);
      t.classList.toggle('is-active', n > 0 && min === curMin);
    });

    /* Kaufleiste */
    var bar = qs('[data-oc-bs-bar]');
    qs('[data-oc-bs-total]').textContent = n > 0 ? money(set) : money(cupPrice + minLidPrice());
    qs('[data-oc-bs-total-was]').textContent = discount > 0 ? money(was) : '';
    qs('[data-oc-bs-saving]').textContent = money(discount);
    qs('[data-oc-bs-saving-chip]').hidden = discount === 0;
    qs('[data-oc-bs-saving-big]').textContent = money(discount);
    qs('[data-oc-bs-live]').hidden = discount === 0;
    var ship = qs('[data-oc-bs-ship]');
    if (ship) ship.hidden = !(n > 0 && set >= FREE_SHIP && geoCountry() === 'DE');

    var next = nextTier(n);
    var hint = qs('[data-oc-bs-next]');
    if (n === 0) hint.textContent = 'Wähle deine erste Deckelfarbe';
    else if (next) { var d = next.min - n; hint.textContent = 'Noch ' + d + (d === 1 ? ' Deckel-Set' : ' Deckel-Sets') + ' bis -' + next.pct + ' % auf alle Deckel'; }
    else hint.textContent = 'Höchste Stufe: -' + pct + ' % auf alle Deckel';
    hint.classList.toggle('is-max', !next && n > 0);

    bar.classList.toggle('is-complete', n > 0);
    bar.classList.toggle('is-empty', false);
    qs('[data-oc-bs-add]').disabled = state.busy || n === 0;
    qs('[data-oc-bs-cta-label]').textContent = n > 0 ? 'Set in den Warenkorb' : 'Deckelfarbe wählen';
    qs('[data-oc-bs-error]').hidden = true;

    /* Zusammenfassung in der Leiste */
    var sum = qs('[data-oc-bs-summary]'), cupLine = qs('[data-oc-bs-sum-cup]'), lidLine = qs('[data-oc-bs-sum-lids]');
    lidLine.innerHTML = '';
    if (n > 0 && CUP) {
      cupLine.textContent = '1× ' + (CUP.subline ? CUP.subline + ' ' : '') + 'Becher';
      chosen.forEach(function (c) {
        var x = document.createElement('span'); x.className = 'oc-bs_summary-lid';
        x.setAttribute('title', c.qty + '× Deckel ' + c.lid.color); x.setAttribute('aria-label', c.qty + '× Deckel ' + c.lid.color);
        var dot = document.createElement('i'); dot.className = 'oc-bs_dot'; dot.style.background = hexOf(c.lid);
        x.appendChild(document.createTextNode(c.qty + '× ')); x.appendChild(dot);
        lidLine.appendChild(x);
      });
    }
    sum.hidden = n === 0;
  }

  /* ---------- Warenkorb ---------- */
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function showError(msg) { var e = qs('[data-oc-bs-error]'); e.textContent = msg; e.hidden = false; }

  qs('[data-oc-bs-add]').addEventListener('click', function () {
    var n = totalLids();
    if (!CUP || n === 0 || state.busy) return;
    var btn = qs('[data-oc-bs-add]');
    state.busy = true; btn.disabled = true; btn.classList.add('is-busy');
    qs('[data-oc-bs-cta-label]').textContent = 'Wird hinzugefügt …';
    var setId = 'bs-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    var props = function (role) { return { _bs_set: SET_NAME, _bs_id: setId, _bs_role: role }; };
    var items = [{ id: CUP.variantId, quantity: 1, properties: props('becher') }];
    Object.keys(state.qty).forEach(function (k) { var l = lidById(parseInt(k, 10)); if (l) items.push({ id: l.variantId, quantity: state.qty[k], properties: props('deckel') }); });

    fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
        try {
          window.dispatchEvent(new CustomEvent('cartupdated', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('toggleminicart', { bubbles: true }));
        } catch (e) {}
        qs('[data-oc-bs-cta-label]').textContent = 'Liegt im Warenkorb';
        setTimeout(function () { state.busy = false; btn.classList.remove('is-busy'); update(); }, 1500);
      })
      .catch(function (err) {
        state.busy = false; btn.classList.remove('is-busy'); update();
        showError(err && err.message ? err.message : 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
      });
  });

  /* ---------- Init ---------- */
  update();
  try { if (window.ocPromo && window.ocPromo.onChange) window.ocPromo.onChange(update); } catch (e) {}

  /* Vorauswahl per URL: ?deckel=<handle> */
  var params = new URLSearchParams(window.location.search);
  var pre = params.get('deckel');
  if (pre) LIDS.forEach(function (l) { if (l.handle === pre && l.available) setQty(l.id, 1); });
  var back = qs('[data-oc-bs-back]');
  if (back && document.referrer && document.referrer.indexOf(window.location.origin) === 0 && history.length > 1) {
    back.addEventListener('click', function (e) { e.preventDefault(); history.back(); });
  }

  /* ---------- Mobil: Kaufleiste fest unten (07.10.2026) ----------
     position: sticky greift auf dem iPhone nicht zuverlässig. Bis zum Ende der Auswahl ist die Leiste
     deshalb per position: fixed unten angeheftet; ihr Platz wird freigehalten, danach läuft sie normal mit. */
  (function () {
    var bar = qs('[data-oc-bs-bar]'), layout = qs('.oc-mm_layout'), main = qs('.oc-mm_main');
    if (!bar || !layout || !main || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 1023px)');
    var st = document.createElement('style');
    st.textContent = '@media screen and (max-width: 1023px){' +
      '.oc-bs.is-bar-fixed .oc-mm_bar{position:fixed;left:0;right:0;bottom:0;margin:0;}' +
      '.oc-bs.is-bar-fixed .oc-mm_layout{padding-bottom:var(--oc-bs-bar-h,0px);}}' +
      '.oc-bs .oc-bs_card .oc-mm_card-img{aspect-ratio:5/6;overflow:hidden;}' + /* Bildformat wie Bloom statt 3:2 (07.10.2026) */
      '.oc-bs .oc-mm_hint:has(+ .oc-bs_grid){display:none;}.oc-bs .oc-bs_grid{margin-top:16px;}'; /* Hinweistext über den Deckeln raus, Abstand Headline → Karten (07.10.2026) */
    document.head.appendChild(st);
    var ticking = false;
    function check() {
      ticking = false;
      if (!mq.matches) { root.classList.remove('is-bar-fixed'); return; }
      var h = bar.offsetHeight;
      root.style.setProperty('--oc-bs-bar-h', h + 'px');
      /* fest, solange die normale Position der Leiste (direkt unter der Auswahl) unterhalb des Bildschirms liegt */
      root.classList.toggle('is-bar-fixed', main.getBoundingClientRect().bottom + h > window.innerHeight);
    }
    function onScroll() { if (!ticking) { ticking = true; setTimeout(check, 0); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (window.ResizeObserver) new ResizeObserver(onScroll).observe(bar);
    check();
  })();
})();
